import { render, staticRenderFns } from "./pptx.vue?vue&type=template&id=369f4f2a&scoped=true"
import script from "./pptx.vue?vue&type=script&lang=js"
export * from "./pptx.vue?vue&type=script&lang=js"
import style0 from "./pptx.vue?vue&type=style&index=0&id=369f4f2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f4f2a",
  null
  
)

export default component.exports